import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

const educationContent = [
  {
    passingYear: "Active",
    degree: "Masters in Business Administration",
    instituteName: "Bangladesh University of Professionals",
  },
  {
    passingYear: "2017-2020",
    degree: "Bsc in Computer Science & Engineering ",
    instituteName:
      "International University of Business Agriculture & Technology",
  },
  {
    passingYear: "2014-2016",
    degree: "Higher Secondary School Certificate ",
    instituteName: "Meherpur Govt. College",
  },
  // {
  //   passingYear: "2014",
  //   degree: "Secondary School Certificate",
  //   instituteName: "Meherpur Govt. High School",
  // },
];

const otherSkillsContent = [
  {
    name: "Git",
    skillPercent: "85",
  },
  {
    name: "Kafka",
    skillPercent: "75",
  },
  {
    name: "Tailwind",
    skillPercent: "86",
  },
  {
    name: "Firebase",
    skillPercent: "82",
  },
  {
    name: "AWS",
    skillPercent: "75",
  },
  {
    name: "Azure",
    skillPercent: "75",
  },
  {
    name: "Linux",
    skillPercent: "80",
  },
  {
    name: "Canva",
    skillPercent: "85",
  },
  {
    name: "Figma",
    skillPercent: "74",
  },
];

const languageFrameworkContent = [
  {
    name: "C",
    skillPercent: "85",
  },
  {
    name: "C++",
    skillPercent: "82",
  },
  {
    name: "Javascript",
    skillPercent: "90",
  },
  {
    name: "TypeScript",
    skillPercent: "85",
  },
  {
    name: "ReactJS",
    skillPercent: "90",
  },
  {
    name: "ExpressJS",
    skillPercent: "86",
  },
  {
    name: "NextJS",
    skillPercent: "84",
  },
  {
    name: "React-Native",
    skillPercent: "78",
  },
  {
    name: "HTML",
    skillPercent: "80",
  },
  {
    name: "CSS",
    skillPercent: "80",
  },
  {
    name: "MongoDB",
    skillPercent: "86",
  },
  {
    name: "MySQL",
    skillPercent: "80",
  },
];

const awardContent = [
  {
    awardYear: "2020",
    degree: "Best Developer",
    instituteName: "University Of Melbourne, NA",
  },
  {
    awardYear: "2019",
    degree: "Best Writter",
    instituteName: "Online Typodev Soluation Ltd.",
  },
  {
    awardYear: "2007",
    degree: "Best Freelancer ",
    instituteName: "Fiver & Upwork Level 2 & Top Rated",
  },
];
const experienceContent = [
  {
    designation: "Sr. Software Tester",
    jobType: "Full Time | Remote",
    year: "2020 - Present",
    compnayName: "Google Inc.",
    descriptions:
      "I design and develop services for customers of all sizes, specializing in creating stylish, modern websites",
  },
  {
    designation: "Sr. Graphic Designer",
    jobType: "Part Time | Office",
    year: "2018 - 2019",
    compnayName: "Avada Theme.",
    descriptions:
      "I design and develop services for customers of all sizes, specializing in creating stylish, modern websites",
  },
  {
    designation: "Cr. Web Developer",
    jobType: "Full Time | InHouse",
    year: "2016 - 2017",
    compnayName: "ib-themes ltd.",
    descriptions:
      "I design and develop services for customers of all sizes, specializing in creating stylish, modern websites",
  },
  {
    designation: "Jr. Web Developer",
    jobType: "Full Time | Remote",
    year: "2014 - 2015",
    compnayName: "Creative Gigs.",
    descriptions:
      "I design and develop services for customers of all sizes, specializing in creating stylish, modern websites",
  },
];

const Skills = () => {
  return (
    <>
      <div className="beny_tm_resume">
        <div className="main_title">
          <h3>Education & Skills</h3>
        </div>

        <div className="resume_inner">
          <div className="row">
            <div
              className="col-4"
              data-aos="fade-right"
              data-aos-duration="1200"
            >
              <div className="education ">
                <div className="edu_list">
                  <h4>
                    <label>Education</label>
                  </h4>
                  <ul>
                    {educationContent.map((val, i) => (
                      <li key={i}>
                        <span className="year">{val.passingYear}</span>
                        <p>
                          <span>{val.degree}</span> - {val.instituteName}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            {/* End .col-4 */}

            <div
              className="col-8"
              data-aos="fade-right"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              <div className="skills ">
                <h4>
                  <label>Skills</label>
                </h4>
                <Tabs>
                  <TabList className="tab_list">
                    <Tab>Language & Frameworks</Tab>
                    <Tab>Tools</Tab>
                  </TabList>
                  <TabPanel>
                    <div className="beny_progress row">
                      {languageFrameworkContent.map((val, i) => (
                        <div className="progress_inner col-4" key={i}>
                          <span>
                            <span className="label">{val.name}</span>
                            <span className="number">{val.skillPercent}%</span>
                          </span>
                          <div className="background">
                            <div className="bar open">
                              <div
                                className="bar_in"
                                style={{ width: val.skillPercent + "%" }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className="beny_progress row">
                      {otherSkillsContent.map((val, i) => (
                        <div className="progress_inner col-4" key={i}>
                          <span>
                            <span className="label">{val.name}</span>
                            <span className="number">{val.skillPercent}%</span>
                          </span>
                          <div className="background">
                            <div className="bar open">
                              <div
                                className="bar_in"
                                style={{ width: val.skillPercent + "%" }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
            {/* End .col-5 */}

            {/* End .col-4 */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Skills;
